// src/services/apis/salesReturnApi.js
import { baseApi } from "../baseApi";

export const salesReturnApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    createSalesReturn: builder.mutation({
      query: (payload) => ({
        url: `/api/method/frappe.model.mapper.make_mapped_doc`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["salesReturn"],
    }),
    saveSalesReturn: builder.mutation({
      query: (payload) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.react_api.save_sales_return`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["salesReturn"],
    }),
    updateSalesReturn: builder.mutation({
      query: (payload) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.react_api.update_sales_return`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["salesReturn"],
    }),
    submitDeliveryNote: builder.mutation({
      query: (payload) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.submit_delivery_note`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["deliveryNote"],
    }),
  }),
});

export const { 
  useCreateSalesReturnMutation,
  useSaveSalesReturnMutation,
  useUpdateSalesReturnMutation,
  useSubmitDeliveryNoteMutation  
} = salesReturnApi;